import { $setStorage } from "@/common/common.js"
import { reject } from "ramda"

const nullCart = {}
const cart = {
  state: {
    cart: nullCart, // 生成product id到 number的散列
  },
  mutations: {
    UPDATE(state, id2number) {
      Object.keys(id2number).forEach((key) => {
        // 删除
        if (id2number[key] == 0) {
          delete state.cart[key]
        } else {
          state.cart[key] = id2number[key]
        }
      })
      $setStorage("cart", state.cart)
    },
    CLEAR(state) {
      //清空购物车
      state.cart = {}
      $setStorage("cart", state.cart)
    },
    SAVE_CART(state, provider) {
      state.cart = provider
    },
    //删除单个购物车商品
    REMOVE_CART(state, provider_id) {
      state.cart = reject(({ product }) => product.id === provider_id)(state.cart)
    },
    //批量删除购物车商品
    BATCH_DELCART(state, cart_id) {
      state.cart = state.cart.filter((item) => {
        return cart_id.indexOf(item.id) == -1
      })
    },
  },
}
export default cart
